import React,{Component} from 'react';
import {Route, BrowserRouter as Router, Switch, Redirect} from 'react-router-dom';
import Home from './component/Home'
import Info from './component/Info'
import Healthy from './component/Healthy'
import RFConditioning from './component/RFConditioning'
import TestRFConditioning from './component/TestRFConditioning'
import News from './component/News'
import Consult from './component/Consult'
import Contact from './component/Contact'
import AboutIntroduce from './component/AboutIntroduce'
import AboutService from './component/AboutService'
import _ from 'lodash';
import Session from './component/Session';
import NewsListNotFree from './component/NewsListNotFree';

class Crouter extends Component{
    render(){
        return (
            <Switch>
                <Route exact path='/' component={Home}/>
                <Route exact path='/home' component={Home}/>
                <Route exact path='/info' component={Info}/>
                <Route exact path='/healthy' component={Healthy}/>
                <Route exact path='/rFConditioning' component={RFConditioning}/>
                <Route exact path='/testRFConditioning' component={TestRFConditioning}/>
                <Route exact path='/consult' component={Consult}/>
                <Route exact path='/news' component={News}/>
                <Route exact path='/contact' component={Contact}/>
                <Route exact path='/aboutIntroduce' component={AboutIntroduce}/>
                <Route exact path='/aboutService' component={AboutService}/>
                <Route exact path='/session' component={Session}/>
                <Route exact path='/news2' component={NewsListNotFree}/>
            </Switch>
        )
    }
}

export default Crouter;



